export default "__VITE_ASSET__BMqdp9BV__"